import axios from 'axios'
import { UrlBase } from './config'

const triggers = {}

triggers.createTrigger = async (token, companyId, appId, data) => {
  const { title, description, onActionType, onCustomActionTypeName, toDo, extraData } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/triggers',
      data: {
        title,
        description,
        onActionType,
        onCustomActionTypeName,
        toDo,
        extraData
      }
    }
    await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

triggers.getTrigger = async (token, companyId, appId, id) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        id
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/triggers'
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e)
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

triggers.getTriggerActionTypesList = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'users/actions/types'
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

triggers.getTriggerToDoList = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/triggers/toDo/list'
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

triggers.getTriggerUsers = async (token, companyId, appId, triggerId, pagination) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/triggers/' + triggerId + '/users',
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage
      }
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

triggers.getTriggers = async (token, companyId, appId, pagination, title, search) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        title,
        search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/triggers'
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

triggers.updateTrigger = async (token, companyId, appId, data) => {
  try {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/triggers',
      data: {
        ...data
      }
    }
    await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

export default triggers
